import { Container } from "react-bootstrap";
import { PrivacySection, PrivacyWrapper } from "../styles";
import { useEffect, useState } from "react";
import {
	getPrivacyPolitics,
	getServiceTerms,
} from "../../../../services/manager/admin/settings.service";
import { ITermsOfService } from "../../../../models/IPrivacyPolicy";
import { useTranslation } from "react-i18next";
import { Loader } from "../../../../components/loader";

export const ToS: React.FC = () => {
	const { t: translate } = useTranslation();

	const [termsOfService, setTermsOfService] = useState<ITermsOfService>();

	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const tosPromise = getServiceTerms()
			.then((data) => {
				setTermsOfService(data);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, []);

	return (
		<PrivacyWrapper>
			<h2>{translate("privacy.tos")}</h2>

			{isLoading && <Loader></Loader>}

			{termsOfService &&
				termsOfService.is_public &&
				termsOfService.body.length > 0 && (
					<PrivacySection>
						<div className="title">{translate("privacy.tos")}</div>
						<div
							className="content"
							dangerouslySetInnerHTML={{
								__html: termsOfService.body,
							}}
						></div>
					</PrivacySection>
				)}

			{!isLoading && termsOfService && !termsOfService.is_public && (
				<PrivacySection>
					<p className="p-3">Documento indisponível no momento.</p>
				</PrivacySection>
			)}
		</PrivacyWrapper>
	);
};
